import { render, staticRenderFns } from "./ApprovalChangesRequested.vue?vue&type=template&id=1d446256&"
import script from "./ApprovalChangesRequested.vue?vue&type=script&lang=ts&"
export * from "./ApprovalChangesRequested.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports